import { render } from "./mat-radio.vue?vue&type=template&id=675d4d88&lang=true"
import script from "./mat-radio.vue?vue&type=script&lang=js"
export * from "./mat-radio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__